import createClient from '../../helpers/api-client';

import { FETCH_SEARCH_PROFILE } from './search-profile-model';

const storeSuffix = 'MyPagesCompany';

// ACTIONS
// company actions
export const FETCH_COMPANY_USER_BY_ID = `fetchCompanyByIdAction${storeSuffix}`;
export const FETCH_COMPANY_REQUESTS = `fetchCompanyRequestsAction${storeSuffix}`;
export const FETCH_COMPANY_ANSWERED_REQUESTS = `fetchCompanyAnsweredRequestsAction${storeSuffix}`;

//mitt konto
export const UPDATE_COMPANY_USER_ACCOUNT_INFO = `updateCompanyUserAccountInfoAction${storeSuffix}`;
export const SAVE_COMPANY_USER_PASSWORD = `UserPasswordAction${storeSuffix}`;
export const SAVE_COMPANY_USER_ACCOUNT_INFO = `UserAccountIno${storeSuffix}`;

//messages
export const UPDATE_COMPANY_USER_MESSAGES = `updateCompanyUserMessagesrMutation${storeSuffix}`; // inte klart
export const UPDATE_HIDDEN_REQUEST = `updateCHiddenRequestMutation${storeSuffix}`;

//profilsidan
export const UPDATE_COMPANY_DATA = `updateCompanyDataAction${storeSuffix}`;
export const SAVE_COMPANY_MAIN_INFO = `MainInfoAction${storeSuffix}`;
export const SAVE_COMPANY_PRESENTATION = `PresentationAction${storeSuffix}`;

// MUTATIONS
// company mutations
export const BEGIN_FETCH_COMPANY_USER = `beginFetchCompanyUserMutation${storeSuffix}`;
export const RECEIVED_COMPANY_USER = `receivedCompanyUserMutation${storeSuffix}`;
export const COMPANY_USER_NOT_FOUND = `companyUserNotFoundMutation${storeSuffix}`;

export const BEGIN_FETCH_COMPANY_REQUESTS = `beginFetchCompanyRequestsMutation${storeSuffix}`;
export const RECEIVED_COMPANY_REQUESTS = `receivedCompanyRequestsMutation${storeSuffix}`;
export const COMPANY_REQUESTS_NOT_FOUND = `companyRequestsNotFoundMutation${storeSuffix}`;

export const BEGIN_FETCH_COMPANY_ANSWERED_REQUESTS = `beginFetchCompanyAnsweredRequestsMutation${storeSuffix}`;
export const RECEIVED_COMPANY_ANSWERED_REQUESTS = `receivedCompanyAnsweredRequestsMutation${storeSuffix}`;
export const COMPANY_ANSWERED_REQUESTS_NOT_FOUND = `companyAnsweredRequestsNotFoundMutation${storeSuffix}`;

export const SET_ANSWERED_REQUESTS_PAGE = `setAnsweredRequestsPageMutation${storeSuffix}`;
export const SET_REQUESTS_PAGE = `setRequestsPageMutation${storeSuffix}`;
export const SET_SHOW_ALL = `setShowAllMutation${storeSuffix}`;
export const RESET_STATE = `resetStateMutation${storeSuffix}`;

// mitt konto
export const CHANGE_COMPANY_USER_ACCOUNT_INFO = `changeCompanyUserAccountInfoMutation${storeSuffix}`;

// messages
export const CHANGE_COMPANY_USER_MESSAGES = `changeCompanyUserMessagesMutation${storeSuffix}`;

// profilsidan
export const CHANGE_COMPANY_DATA = `changeCompanyDataMutation${storeSuffix}`;

// save mutations
export const BEGIN_SAVE = `beginSaveMutation${storeSuffix}`;
export const SAVE_COMPLETED = `saveCompletedMutation${storeSuffix}`;
export const SAVE_ERROR = `saveErrorMutation${storeSuffix}`;

// GETTERS
// global getters
export const IS_LOADING = `getIsLoadingGetter${storeSuffix}`;
export const GET_ERROR = `getErrorGetter${storeSuffix}`;
export const GET_ACTIVE_REQUEST_SERVICE = `getActiveRequestServcieGetter${storeSuffix}`;
export const GET_ADDITIONAL_SERVICE = `getAdditionalRequestServcieGetter${storeSuffix}`;

export const REQUESTS_LOADING = `requestsMeta.loadingGetter${storeSuffix}`;
export const ANSWERED_REQUESTS_LOADING = `answeredRequestsLoadingGetter${storeSuffix}`;
export const GET_REQUESTS_ERROR = `getRequestsErrorGetter${storeSuffix}`;
export const GET_ANSWERED_REQUESTS_ERROR = `getAnsweredRequestsErrorGetter${storeSuffix}`;
export const GET_REQUESTS_PAGE = `getRequestsPageGetter${storeSuffix}`;
export const GET_SHOW_ALL = `getShowAllGetter${storeSuffix}`;
export const GET_ANSWERED_REQUESTS_PAGE = `getAnsweredRequestsPageGetter${storeSuffix}`;
export const GET_REQUEST_META = `getRequestsMeta${storeSuffix}`;

export const GET_CALCULATED_ACTIVE_SERVICE_PRICE = `getCalculatedActiveServicePriceGetter${storeSuffix}`;

export const GET_IS_TRIAL_USER = `getIsTrialUserGetter${storeSuffix}`;

// save getters
export const GET_SAVE_ERROR = `getSaveErrorGetter${storeSuffix}`;

// user company getters
export const GET_COMPANY_USER = `getCompanyUserGetter${storeSuffix}`;
export const GET_COMPANY_REQUESTS = `getCompanyRequestsGetter${storeSuffix}`;

//user company get templates
export const GET_COMPANY_MAIL_TEMPLATES = `getCompanyMailTemplates${storeSuffix}`;
export const DELETE_COMPANY_MAIL_TEMPLATE = `deleteCompanyMailTemplate${storeSuffix}`;
export const ADD_COMPANY_MAIL_TEMPLATE = `addCompanyMailTemplate${storeSuffix}`;
export const UPDATE_COMPANY_MAIL_TEMPLATE = `updateCompanyMailTemplate${storeSuffix}`;

export const RECIEVED_COMPANY_MAIL_TEMPLATES = `recievedCompanyMailTemplates${storeSuffix}`;

export const modelState = () => ({
    myPagesCompany: {
        isLoading: false,
        error: null,
        requestsMeta: {
            loading: false,
            error: false,
            page: 1,
            showAll: 0
        },
        answeredRequestsMeta: {
            loading: false,
            error: false,
            page: 1,
            showAll: 0
        },
        saveErrors: {
            accountInfo: null,
            password: null,
            mainInfo: null,
            presentation: null
        },
        data: {
            Company: {},
            User: {},
            Requests: {
                Meta: null,
                Answered: {
                    data: [],
                    count: null
                },
                Unanswered: {
                    data: [],
                    count: null
                }
            },
            MailTemplates: []
        }
    }
});

export const actions = {
    // company actions
    [FETCH_COMPANY_USER_BY_ID]: ({ state, commit, dispatch }) => {
        return new Promise(async (resolve, reject) => {
            const apiClient = createClient(state);

            commit(BEGIN_FETCH_COMPANY_USER);

            try {
                const res = await apiClient.get(`/api/my-pages/company`);
                commit(RECEIVED_COMPANY_USER, res);

                resolve(res);
            } catch (error) {
                let message = 'Något gick fel. Ladda om sidan.';
                commit(COMPANY_USER_NOT_FOUND, message);
                reject(error);
            }
        });
    },
    [FETCH_COMPANY_REQUESTS]: ({ state, commit }) => {
        return new Promise(async (resolve, reject) => {
            const apiClient = createClient(state);

            const page = state.myPagesCompany.requestsMeta.page;
            const showAll = state.myPagesCompany.requestsMeta.showAll;

            commit(BEGIN_FETCH_COMPANY_REQUESTS);

            try {
                const res = await apiClient.get(
                    `/api/my-pages/company/requests`,
                    { params: { take: 25, page: page, showAll: showAll } }
                );
                commit(RECEIVED_COMPANY_REQUESTS, res);

                resolve(res);
            } catch (error) {
                commit(COMPANY_REQUESTS_NOT_FOUND);
                reject(error);
            }
        });
    },
    [FETCH_COMPANY_ANSWERED_REQUESTS]: ({ state, commit }) => {
        return new Promise(async (resolve, reject) => {
            const apiClient = createClient(state);

            const page = state.myPagesCompany.answeredRequestsMeta.page;
            const showAll = state.myPagesCompany.answeredRequestsMeta.showAll;
            //console.log(`showAll i fetch - XXX - ${showAll}`);

            commit(BEGIN_FETCH_COMPANY_ANSWERED_REQUESTS);

            try {
                const res = await apiClient.get(
                    `/api/my-pages/company/requests/answered`,
                    { params: { take: 25, page: page, showAll: showAll } }
                );
                commit(RECEIVED_COMPANY_ANSWERED_REQUESTS, res);

                resolve(res);
            } catch (error) {
                commit(COMPANY_ANSWERED_REQUESTS_NOT_FOUND);
                reject(error);
            }
        });
    },
    [UPDATE_HIDDEN_REQUEST]: ({ state, commit }, data) => {
        console.dir({ data });
        return new Promise(async (resolve, reject) => {
            const apiClient = createClient(state);
            const rid = data.Id;
            const hide = data.IsHidden ? 0 : 1;
            var uid = 0;
            try {
                //uid = parseInt(JSON.parse(state.authentication.user.userId),10);
                uid = parseInt(
                    (typeof state.authentication.user === 'string'
                        ? JSON.parse(state.authentication.user)
                        : state.authentication.user
                    ).userId,
                    10
                );
                const res = await apiClient.get(`/api/request/additional`, {
                    params: { rId: rid, hide: hide, uId: uid }
                });
                console.log('Update res', res);
                //commit(RECEIVED_COMPANY_ANSWERED_REQUESTS, res);

                resolve(res);
            } catch (error) {
                //commit(COMPANY_ANSWERED_REQUESTS_NOT_FOUND);
                console.error('Update res exception', error.message);
                reject(error);
            }
        });
    },
    [UPDATE_COMPANY_USER_ACCOUNT_INFO]: ({ state, commit }, data) => {
        return new Promise(async (resolve, reject) => {
            commit(CHANGE_COMPANY_USER_ACCOUNT_INFO, data);
            resolve();
        });
    },
    [UPDATE_COMPANY_DATA]: ({ state, commit }, data) => {
        return new Promise(async (resolve, reject) => {
            commit(CHANGE_COMPANY_DATA, data);
            resolve();
        });
    },
    [SAVE_COMPANY_USER_ACCOUNT_INFO]: ({ state, commit }) => {
        return new Promise(async (resolve, reject) => {
            const apiClient = createClient(state);

            commit(BEGIN_SAVE, 'accountInfo');

            try {
                let data = {
                    Name: state.myPagesCompany.data.User.Name,
                    Email: state.myPagesCompany.data.User.Email,
                    Phone: state.myPagesCompany.data.User.Phone,
                    Newsletter: state.myPagesCompany.data.User.Newsletter
                };
                const res = await apiClient.post(
                    `/api/my-pages/company/account`,
                    data
                );
                commit(SAVE_COMPLETED, 'accountInfo');
                resolve(res);
            } catch (error) {
                let message = 'Något gick fel.';
                commit(SAVE_ERROR, { key: 'accountInfo', error: message });
                reject(error);
            }
        });
    },
    [SAVE_COMPANY_USER_PASSWORD]: ({ state, commit }, data) => {
        return new Promise(async (resolve, reject) => {
            const apiClient = createClient(state);

            commit(BEGIN_SAVE, 'password');

            try {
                const res = await apiClient.post(
                    `/api/my-pages/update-password`,
                    data
                );
                commit(SAVE_COMPLETED, 'password');
                resolve(res);
            } catch (error) {
                commit(SAVE_ERROR, { key: 'password', error: error.Message });
                reject(error);
            }
        });
    },
    [SAVE_COMPANY_MAIN_INFO]: ({ state, commit }, file) => {
        return new Promise(async (resolve, reject) => {
            const apiClient = createClient(state, {
                headers: {
                    Authorization: `Bearer ${
                        state.authentication.authenticationToken
                    }`,
                    'Content-Type': 'multipart/form-data'
                }
            });
            commit(BEGIN_SAVE, 'mainInfo');

            let data = {
                VisitAddress: state.myPagesCompany.data.Company.VisitAddress,
                VisitCity: state.myPagesCompany.data.Company.VisitCity.trim(),
                Phone: state.myPagesCompany.data.Company.Phone,
                Email: state.myPagesCompany.data.Company.Email,
                Url: state.myPagesCompany.data.Company.Url,
                Logo: state.myPagesCompany.data.Company.Logo
            };

            if (file) {
                data.Logo = file;
            } else {
                if (state.myPagesCompany.data.Company.Logo == null) {
                    delete data.Logo;
                }
            }

            let formData = new FormData();

            Object.keys(data).forEach(key => {
                formData.append(key, data[key]);
            });

            try {
                const res = await apiClient.post(
                    `/api/my-pages/company/main-info`,
                    formData
                );
                commit(SAVE_COMPLETED, 'mainInfo');
                resolve(res);
            } catch (error) {
                let message = 'Något gick fel. Försök igen.';
                commit(SAVE_ERROR, { key: 'mainInfo', error: message });
                reject(error);
            }
        });
    },
    [SAVE_COMPANY_PRESENTATION]: ({ state, commit }, file) => {
        return new Promise(async (resolve, reject) => {
            const apiClient = createClient(state, {
                headers: {
                    Authorization: `Bearer ${
                        state.authentication.authenticationToken
                    }`,
                    'Content-Type': 'multipart/form-data'
                }
            });

            commit(BEGIN_SAVE, 'presentation');

            let data = {
                Presentation: state.myPagesCompany.data.Company.Presentation,
                Image: state.myPagesCompany.data.Company.Image
            };

            console.log('SAVE_COMPANY_PRESENTATION file', file);

            if (file) {
                data.Image = file;
            } else {
                if (state.myPagesCompany.data.Company.Image == null) {
                    delete data.Image;
                }
            }

            let formData = new FormData();
            Object.keys(data).forEach(key => {
                formData.append(key, data[key]);
            });

            try {
                const res = await apiClient.post(
                    `/api/my-pages/company/presentation`,
                    formData
                );
                commit(SAVE_COMPLETED, 'presentation');
                resolve(res);
            } catch (error) {
                let message = 'Något gick fel. Försök igen.';
                commit(SAVE_ERROR, { key: 'presentation', error: message });
                reject(error);
            }
        });
    },
    [GET_COMPANY_MAIL_TEMPLATES]: ({ state, commit }, data) => {
        console.dir({ data });
        return new Promise(async (resolve, reject) => {
            const apiClient = createClient(state);

            var userId = 0;
            try {
                userId = parseInt(
                    (typeof state.authentication.user === 'string'
                        ? JSON.parse(state.authentication.user)
                        : state.authentication.user
                    ).userId,
                    10
                );
                const res = await apiClient.get(
                    `/api/metadata/mailtemplates/${userId}`
                );
                commit(RECIEVED_COMPANY_MAIL_TEMPLATES, res);

                resolve(res);
            } catch (error) {
                //commit(COMPANY_ANSWERED_REQUESTS_NOT_FOUND);
                console.error('mail templates exception', error.message);
                reject(error);
            }
        });
    },
    [ADD_COMPANY_MAIL_TEMPLATE]: ({ state, commit }, data) => {
        return new Promise(async (resolve, reject) => {
            const apiClient = createClient(state);

            commit(BEGIN_SAVE, 'email');
            var userId = 0;
            try {
                userId = parseInt(
                    (typeof state.authentication.user === 'string'
                        ? JSON.parse(state.authentication.user)
                        : state.authentication.user
                    ).userId,
                    10
                );
                const res = await apiClient.post(
                    `/api/company/${userId}/addEmailTemplate`,
                    data
                );
                commit(SAVE_COMPLETED, 'email');
                resolve(res);
            } catch (error) {
                commit(SAVE_ERROR, { key: 'email', error: error.Message });
                reject(error);
            }
        });
    },
    [UPDATE_COMPANY_MAIL_TEMPLATE]: ({ state, commit }, data) => {
        return new Promise(async (resolve, reject) => {
            const apiClient = createClient(state);

            commit(BEGIN_SAVE, 'email');
            var userId = 0;
            try {
                userId = parseInt(
                    (typeof state.authentication.user === 'string'
                        ? JSON.parse(state.authentication.user)
                        : state.authentication.user
                    ).userId,
                    10
                );
                const res = await apiClient.post(
                    `/api/company/${userId}/updateEmailTemplate`,
                    data
                );
                commit(SAVE_COMPLETED, 'email');
                resolve(res);
            } catch (error) {
                commit(SAVE_ERROR, { key: 'email', error: error.Message });
                reject(error);
            }
        });
    },
    [DELETE_COMPANY_MAIL_TEMPLATE]: ({ state, commit }, mailTemplateId) => {
        return new Promise(async (resolve, reject) => {
            const apiClient = createClient(state);

            var userId = 0;
            try {
                userId = parseInt(
                    (typeof state.authentication.user === 'string'
                        ? JSON.parse(state.authentication.user)
                        : state.authentication.user
                    ).userId,
                    10
                );
                const res = await apiClient.delete(
                    `/api/company/${userId}/deleteEmailTemplate/${mailTemplateId}`
                );
                resolve(res);
            } catch (error) {
                reject(error);
            }
        });
    }
};

export const mutations = {
    [RECIEVED_COMPANY_MAIL_TEMPLATES]: (state, payload) => {
        const { data } = payload;
        state.myPagesCompany.data.MailTemplates = data;
        console.log(
            'recieved, ',
            data,
            state.myPagesCompany.data.MailTemplates,
            state
        );
    },
    // company mutations
    [BEGIN_FETCH_COMPANY_USER]: state => {
        state.myPagesCompany.isLoading = true;
        state.myPagesCompany.error = false;
    },
    [RECEIVED_COMPANY_USER]: (state, payload) => {
        const { data } = payload;
        state.myPagesCompany.isLoading = false;
        state.myPagesCompany.error = false;
        state.myPagesCompany.data.Company = data.Company;
        state.myPagesCompany.data.User = data.User;

        if (data.User && data.User.Services) {
            state.myPagesCompany.data.User.activeService = data.User.Services.find(
                item => {
                    // ServiceTypeId == 1 is matchingservice and Status.Id == 3 means active
                    return item.ServiceTypeId == 1 && item.Status.Id == 3;
                }
            );

            state.myPagesCompany.data.User.additionalService = data.User.Services.find(
                item => item.ServiceTypeId == 5
            );
        }
    },
    [COMPANY_USER_NOT_FOUND]: (state, payload) => {
        state.myPagesCompany.isLoading = false;
        state.myPagesCompany.error = payload;
    },
    [BEGIN_FETCH_COMPANY_REQUESTS]: state => {
        state.myPagesCompany.requestsMeta.loading = true;
        state.myPagesCompany.requestsMeta.error = false;
    },
    [BEGIN_FETCH_COMPANY_ANSWERED_REQUESTS]: state => {
        state.myPagesCompany.answeredRequestsMeta.loading = true;
        state.myPagesCompany.answeredRequestsMeta.error = false;
    },
    [RECEIVED_COMPANY_REQUESTS]: (state, payload) => {
        const { data } = payload;
        state.myPagesCompany.requestsMeta.loading = false;
        state.myPagesCompany.requestsMeta.error = false;
        state.myPagesCompany.data.Requests.Unanswered.data = data.Requests;
        state.myPagesCompany.data.Requests.Unanswered.count = data.Count;
        state.myPagesCompany.data.Requests.Meta = data.Statistics;
    },
    [RECEIVED_COMPANY_ANSWERED_REQUESTS]: (state, payload) => {
        const { data } = payload;
        state.myPagesCompany.answeredRequestsMeta.loading = false;
        state.myPagesCompany.answeredRequestsMeta.error = false;
        state.myPagesCompany.data.Requests.Answered.data = data.Requests;
        state.myPagesCompany.data.Requests.Answered.count = data.Count;
    },
    [COMPANY_REQUESTS_NOT_FOUND]: state => {
        state.myPagesCompany.requestsMeta.loading = false;
        state.myPagesCompany.requestsMeta.error = true;
    },
    [COMPANY_ANSWERED_REQUESTS_NOT_FOUND]: state => {
        state.myPagesCompany.answeredRequestsMeta.loading = false;
        state.myPagesCompany.answeredRequestsMeta.error = true;
    },
    [SET_ANSWERED_REQUESTS_PAGE]: (state, page) => {
        state.myPagesCompany.answeredRequestsMeta.page = page;
    },
    [SET_REQUESTS_PAGE]: (state, page) => {
        state.myPagesCompany.requestsMeta.page = page;
    },
    [SET_SHOW_ALL]: (state, showState) => {
        state.myPagesCompany.requestsMeta.showAll = showState;
        state.myPagesCompany.answeredRequestsMeta.showAll = showState;
    },
    [CHANGE_COMPANY_USER_ACCOUNT_INFO]: (state, payload) => {
        Object.keys(payload).forEach(function(key) {
            if (state.myPagesCompany.data.User.hasOwnProperty(key)) {
                const company = state.myPagesCompany.data.User;
                company[key] = payload[key];
                state.myPagesCompany.data.User = company;
                return;
            }
        });
    },
    [CHANGE_COMPANY_DATA]: (state, payload) => {
        Object.keys(payload).forEach(function(key) {
            if (state.myPagesCompany.data.Company.hasOwnProperty(key)) {
                const company = state.myPagesCompany.data.Company;
                company[key] = payload[key];
                state.myPagesCompany.data.Company = company;
                return;
            }
        });
    },

    // save mutations
    [BEGIN_SAVE]: (state, key) => {
        state.myPagesCompany.saveErrors[key] = null;
    },
    [SAVE_COMPLETED]: (state, key) => {
        state.myPagesCompany.saveErrors[key] = null;
    },
    [SAVE_ERROR]: (state, { key, error }) => {
        state.myPagesCompany.saveErrors[key] = error;
    },
    [RESET_STATE]: state => {
        state.myPagesCompany.requestsMeta = {
            loading: false,
            error: false,
            page: 1,
            showAll: 0
        };
        state.myPagesCompany.answeredRequestsMeta = {
            loading: false,
            error: false,
            page: 1,
            showAll: 0
        };
        state.myPagesCompany.saveErrors = {
            accountInfo: null,
            password: null,
            mainInfo: null,
            presentation: null
        };
        state.myPagesCompany.data = {
            Company: {},
            User: {},
            Requests: {
                Meta: null,
                Answered: {
                    data: [],
                    count: null
                },
                Unanswered: {
                    data: [],
                    count: null
                }
            }
        };
    }
};

export const getters = {
    // global getters
    [IS_LOADING]: state => {
        return state.myPagesCompany.isLoading;
    },
    [GET_ERROR]: state => {
        return state.myPagesCompany.error;
    },
    [GET_ACTIVE_REQUEST_SERVICE]: state => {
        return state.myPagesCompany.data.User.activeService;
    },
    [GET_ADDITIONAL_SERVICE]: state => {
        return state.myPagesCompany.data.User.additionalService;
    },
    [REQUESTS_LOADING]: state => {
        return state.myPagesCompany.requestsMeta.loading;
    },
    [ANSWERED_REQUESTS_LOADING]: state => {
        return state.myPagesCompany.answeredRequestsMeta.loading;
    },
    [GET_REQUESTS_ERROR]: state => {
        return state.myPagesCompany.requestsMeta.error;
    },
    [GET_ANSWERED_REQUESTS_ERROR]: state => {
        return state.myPagesCompany.answeredRequestsMeta.error;
    },
    [GET_REQUESTS_PAGE]: state => {
        return state.myPagesCompany.requestsMeta.page;
    },
    [GET_SHOW_ALL]: state => {
        return state.myPagesCompany.requestsMeta.showAll;
    },
    [GET_ANSWERED_REQUESTS_PAGE]: state => {
        return state.myPagesCompany.answeredRequestsMeta.page;
    },
    [GET_REQUEST_META]: state => {
        return state.myPagesCompany.data.Requests.Meta;
    },
    [GET_CALCULATED_ACTIVE_SERVICE_PRICE]: state => {
        if (
            state.myPagesCompany.data.User.activeService &&
            state.myPagesCompany.data.User.activeService.Price
        ) {
            let price = state.myPagesCompany.data.User.activeService.Price;
            let paymentTerm =
                state.myPagesCompany.data.User.activeService.PaymentTerm || 1;

            return price / paymentTerm;
        }
        return null;
    },
    // save getters
    [GET_SAVE_ERROR]: state => {
        return key => {
            return state.myPagesCompany.saveErrors[key];
        };
    },

    //company getters
    [GET_COMPANY_USER]: state => {
        return state.myPagesCompany.data;
    },
    [GET_COMPANY_REQUESTS]: state => {
        return state.myPagesCompany.data.Requests;
    },
    [GET_IS_TRIAL_USER]: state => {
        const { services = [] } = state.myPagesCompany.data.User;
        let isTrial = false;

        services.forEach(s => {
            if (s.Status.Id === 3 && s.ServiceId === 44) {
                isTrial = true;
            }
        });

        return isTrial;
    }
};



// WEBPACK FOOTER //
// ./src/store/store-models/my-pages-company-model.js